export default function DotsAndBoxesIcon() {
  const dots = [10, 32, 54];
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" fill="none" strokeLinecap="round">
      <rect x="10" y="10" width="22" height="22" fill="#2F8BFF" opacity="0.35" />
      <rect x="32" y="32" width="22" height="22" fill="#FF8A1F" opacity="0.35" />
      <path d="M10 10h22v22H10z" stroke="#2F8BFF" strokeWidth="4" strokeLinejoin="round" />
      <path d="M32 32h22v22H32zM32 10h22" stroke="#FF8A1F" strokeWidth="4" strokeLinejoin="round" />
      <path d="M10 54h22" stroke="#3B434F" strokeWidth="4" />
      {dots.map((x) => dots.map((y) => <circle key={`${x}-${y}`} cx={x} cy={y} r="4.5" fill="#E7ECF3" />))}
    </svg>
  );
}
